module.exports = __webpack_public_path__ + "media/images/logo - Copy-45ce6b1104e36b54824f50992d4bd505.svg";